


























































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Getter, Action, namespace } from 'vuex-class';
import { Product } from "@/pitprojekt/models/Product";
import { Utils } from '@/pitprojekt/utils'
import moment from 'moment'
const SettingsModule = namespace('SettingsModule')
import _ from 'lodash'

@Component({})
export default class PageTitle extends Vue {
@Prop(String) title!: string
@Prop(Array) breadcrumbs!: object

@SettingsModule.Getter('dateFrom') dateFrom!: string;
@SettingsModule.Getter('dateTo') dateTo!: string;
@SettingsModule.Getter('filterProductsToPitOnly') filterProductsToPitOnly!: boolean;
@SettingsModule.Getter('currentUserProducts') currentUserProducts!: Array<Product>;
@SettingsModule.Getter('currentUserProductsPitOnly') currentUserProductsPitOnly!: Array<Product>;
@SettingsModule.Getter('selectedProducts') selectedProducts!: Array<number>;
@SettingsModule.Getter('selectedProduct') selectedProduct!: Array<number>;
@SettingsModule.Getter('multipleProducts') multipleProducts!: boolean;
@SettingsModule.Getter('lastYear') lastYear!: boolean;
@SettingsModule.Action('changeDateFrom') changeDateFrom: any;
@SettingsModule.Action('changeDateTo') changeDateTo: any;
@SettingsModule.Action('changeSelectedProducts') changeSelectedProducts: any;
@SettingsModule.Action('changeSelectedProduct') changeSelectedProduct: any;
@SettingsModule.Action('setDefaultSelectedProduct') setDefaultSelectedProduct: any;
@SettingsModule.Action('changeLastYear') changeLastYear: any;
dateFromMenu :boolean = false;
dateToMenu :boolean = false;

get selectProductsModel() {
  return (this.multipleProducts) ? this.selectedProducts : this.selectedProduct;
}

set selectProductsModel(value: any) {
  if (this.multipleProducts)
    this.changeSelectedProducts(value);
  else
    this.changeSelectedProduct(value);
}

get lastYearModel(): boolean {
  return this.lastYear;
}

set lastYearModel(value: boolean) {
    this.changeLastYear(value);
}

get dateFromModel(): string {
  return this.dateFrom;
}

set dateFromModel(value: string) {
    this.changeDateFrom(value);
}

get dateToModel(): string {
  return this.dateTo;
}

set dateToModel(value: string) {
    this.changeDateFrom(value);
}


created() {
  if (_.isEmpty(this.selectedProducts) && !_.isEmpty(this.currentUserProducts)) {
    this.setDefaultSelectedProduct();
  }
}

get currentUserProductsDataProvider() {
  return (this.filterProductsToPitOnly) ? this.currentUserProductsPitOnly : this.currentUserProducts;
}

getProductIconName(rodzaj: string): string {
  return  Utils.getProductIconName(rodzaj)
}

}
